// import React, { useEffect, useState } from "react";
// import { MeetupsTableItemType } from "../../../types";
// import upload from "../../../assets/svg/upload-blue.svg";
// import TextControlBtns from "../../TextControlBtns/TextControlBtns";
// import schedule from "../../../assets/svg/schedule-gray.svg";
// type Props = {
//   currentMeet: MeetupsTableItemType | null;
//   setCurrentMeet: (value: MeetupsTableItemType | null) => void;
//   setNewMeetup: (value: MeetupsTableItemType | null) => void;
// };

// export default function MeetupsAddForm({ currentMeet, setNewMeetup }: Props) {
//   const [title, setTitle] = useState(currentMeet?.title || "");
//   const [descr, setDescr] = useState(currentMeet?.descr || "");
//   const [department, setDepartment] = useState(currentMeet?.department || "");
//   const [category, setCategory] = useState(currentMeet?.category || "");
//   const [date, setDate] = useState(currentMeet?.created_at || "");

//   const handleTitleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const newTitle = e.target.value;
//     if (newTitle.length > 60) return;
//     setTitle(newTitle);
//   };

//   const handleDescrInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
//     const newDescr = e.target.value;
//     if (newDescr.length > 800) return;
//     setDescr(newDescr);
//   };

//   const handleDepartmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     setDepartment(e.target.value);
//   };

//   const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     setCategory(e.target.value);
//   };

//   const handleDateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     setDate(e.target.value);
//   };

//   useEffect(() => {
//     const newMeet = {
//       id: 2,
//       title: title,
//       created_at: date,
//       status: "pending",
//       category: category,
//       img: "string",
//       department: department,
//       descr: descr,
//     };
//     setNewMeetup(newMeet);
//   }, [title, descr, department, category, date]);

//   return (
//     <div className="">
//       <div className="flex gap-6">
//         <div className="w-1/2 flex flex-col h-auto justify-between">
//           <p className="text-[#5F6B88] text-sm font-medium">
//             Обложка мероприятия
//           </p>
//           {currentMeet?.img ? (
//             <img className="rounded-md mt-2" src={currentMeet?.img} alt="" />
//           ) : (
//             <div className="border border-[#0068FF] py-3 px-8 flex text-[#0068FF] text-base font-semibold items-center justify-center gap-2 rounded-md cursor-pointer">
//               <label htmlFor="file-upload" className="flex items-center gap-2">
//                 <img src={upload} alt="upload" /> Загрузить
//               </label>
//               <input id="file-upload" className="hidden" type="file" />
//             </div>
//           )}
//           <p className="text-[#AFB7CA] mt-1 text-xs font-medium">
//             JPG, PNG | Не более 1200x800px, 10MB
//           </p>
//         </div>
//         <div className="flex flex-col gap-2 w-1/2">
//           <label htmlFor="department" className="text-sm text-gray-700">
//             Департамент
//           </label>
//           <select
//             id="department"
//             className="border border-gray-200 rounded-md p-2 w-full focus:outline-none bg-blue-100 opacity-[0.4] text-black"
//             value={department}
//             onChange={handleDepartmentChange}
//           >
//             <option value="">Все</option>
//             <option value="admin1">Департамент 1</option>
//             <option value="admin2">Департамент 2</option>
//             <option value="admin3">Департамент 3</option>
//           </select>

//           <label htmlFor="category" className="text-sm text-gray-700">
//             Категория
//           </label>
//           <select
//             id="category"
//             className="border border-gray-200 rounded-md p-2 w-full focus:outline-none bg-blue-100 opacity-[0.4] text-black"
//             value={category}
//             onChange={handleCategoryChange}
//           >
//             <option value="">Все</option>
//             <option value="category1">Категория 1</option>
//             <option value="category2">Категория 2</option>
//             <option value="category3">Категория 3</option>
//           </select>

//           <label htmlFor="date" className="text-sm text-gray-700">
//             Дата
//           </label>
//           <div className="flex justify-around bg-blue-100 rounded-md opacity-[0.4]">
//             <select
//               id="date"
//               className="border border-gray-200 rounded-md p-2 w-full focus:outline-none bg-blue-100 opacity-[0.4] text-black"
//               value={date}
//               onChange={handleDateChange}
//             >
//               <option value="">Дата</option>
//               <option value="01.01.2024">1 Января 2024</option>
//               <option value="01.02.2024">1 Февраля 2024</option>
//               <option value="01.02.2024">1 Марта 2024</option>
//             </select>

//             <img src={schedule} alt="" />
//           </div>
//         </div>
//       </div>
//       <div className="mt-6 position-relative">
//         <p className="text-sm text-[#5F6B88] font-medium">
//           Заголовок мероприятия
//         </p>
//         <input
//           className="mt-2 rounded-md px-4 py-3 w-full focus:outline-none bg-[#F0F3FA] text-black"
//           type="text"
//           value={title}
//           onChange={handleTitleInput}
//         />
//         <p className="text-[#AFB7CA] text-xs font-medium pl-4">
//           {title.length}/60
//         </p>
//         <p className="mt-6 text-sm text-[#5F6B88] font-medium">
//           Текст мероприятия
//         </p>
//         <div className="relative">
//           <textarea
//             className="mt-2 rounded-md px-4 py-3 w-full focus:outline-none bg-[#F0F3FA] text-black resize-none h-[40vh] pr-[60px]"
//             placeholder="Текст описания"
//             value={descr}
//             onChange={handleDescrInput}
//           />
//           <div className="absolute bottom-4 left-4">
//             <TextControlBtns />
//           </div>
//         </div>
//         <p className="text-[#AFB7CA] text-xs font-medium pl-4">
//           {descr.length}/800
//         </p>
//       </div>
//     </div>
//   );
// }

import { useHookstate } from "@hookstate/core";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { simpleGetter } from "../../../actions/common";
import { activitiesApi } from "../../../api/api";
import mock1 from "../../../assets/png/mock1.png";
import { useUniversalFind, useUniversalFindAll } from "../../../hooks/universal";
import { addEventFormFields, targetAudienceEmptyOption } from "../../../misc/constants";
import { Activity, ActivityTargetAudience, AddEventFormFields, ClubCategory, Department } from "../../../types";
import { CustomDateInput } from "../../CustomDateInput";
import { ImageUploadWithPreview } from "../../ImageUploadWithPreview";
import InputField from "../../input-field/InputField";
import AddFormBtns from "./AddFormBtns";
import DefaultButton from "../../default-button/DefaultButton";
import Tick from "../../../assets/icons/Tick";
import TrashRed from "../../../assets/icons/TrashRed";
import { showSnackbar } from "../../../misc/utils";
import { accessGlobalMiscState, useGlobalMiscState } from "../../../stores/misc";
import { useGlobalUserState } from "../../../stores/user";

type AddEventFormState = {
  form: AddEventFormFields
}

type AddEventCardProps = {
  onAddEvent: (e: any) => void;
  onClose: (e: any) => void;
}

type MeetupsAddFormProps = {
  onClose: () => void;
}

export default function MeetupsAddForm({ onClose }: MeetupsAddFormProps) {
  const miscState = useGlobalMiscState();
  const userState = useGlobalUserState();
  const user = userState.get();
  const uniqUser = user.uniqUser || {};
  const configLabels: Record<string, any>[] = useUniversalFind('Config', {
    key: ['activity_expected_reach', 'activity_levels']
  })
  const activityExpectedReach: string[] = configLabels.find(c => c.key === "activity_expected_reach")?.value || []
  const activityLevels: string[] = configLabels.find(c => c.key === "activity_levels")?.value || []
  const departments: Department[] = useUniversalFindAll('Department')
  const categories: ClubCategory[] = useUniversalFindAll('ActivityCategory')
  const targetAudiences: ActivityTargetAudience[] = useUniversalFindAll('ActivityTargetAudience')
  const meetupsFormEditItem: any = miscState.get('meetupsFormEditItem');
  const [title, setTitle] = useState("");
  const [descr, setDescr] = useState("");
  const [isUrlChecked, setIsUrlChecked] = useState(false);
  const [url, setUrl] = useState("");
  const [status, setStatus] = useState("");
  const [img, setImg] = useState(mock1);

  const localState = useHookstate({
    form: new AddEventFormFields()
  } as AddEventFormState);
  const state = localState.get();
  const form = state.form;

  const validateFormFields = () => {
    return (
      form.department_id &&
      form.category_id &&
      form.start_date &&
      form.end_date &&
      form.name &&
      form.description &&
      form.activity_target_audience_id &&
      form.location &&
      form.expected_reach &&
      form.level &&
      form.end_date > form.start_date
    );
  };

  const updateForm = (key: keyof AddEventFormFields, value: any) => {
    localState.form[key].set(value);
  }

  const onFormInputChangeRaw = (key: keyof AddEventFormFields) => (value: any) => {
    updateForm(key, value);
  }

  const onFormInputChangeDate = (key: keyof AddEventFormFields) => (date: Date | null) => {
    updateForm(key, date);
  }


  const onFormInputChange = (key: keyof AddEventFormFields, type: string) => (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLSelectElement>) => {
    const target = e.target;

    switch (type) {
      case 'file':
        if (target instanceof HTMLInputElement && target.files?.length) {
          const reader = new FileReader();
          reader.onload = function (event) {
            // @ts-ignore
            localState.form[`${key}Base64`].set(event.target?.result)
            // @ts-ignore
            localState.form[key].set(target.files?.[0])
          }
          reader.readAsDataURL(target.files[0]);
        }
        break;
      case 'text':
      case 'select':
        updateForm(key, e.target.value);
        break;
      case 'checkbox':
        if (target instanceof HTMLInputElement) {
          updateForm(key, target.checked ? 1 : 0);
        }
    }
  }

  useEffect(() => {
    if (meetupsFormEditItem?.id) {
      const existingObject: Record<string, any> = {
        id: meetupsFormEditItem.id,
      };
      for (const f of addEventFormFields) {
        if (f in meetupsFormEditItem) {
          if (["start_date", "end_date"].includes(f)) {
            existingObject[f] = new Date(meetupsFormEditItem[f]);
          } else {
            existingObject[f] = meetupsFormEditItem[f];
          }
        }
      }
      if (!meetupsFormEditItem.activity_target_audience_id) {
        existingObject.activity_target_audience_id = "0";
      }
      localState.form.merge(existingObject);
    }
  }, [meetupsFormEditItem?.id]);

  const onSubmit = async () => {
    const formData = new FormData();
    for (const f of addEventFormFields) {
      let value = form[f];

      if (f === "activity_target_audience_id" && (!value || value === "0")) {
        continue;
      }

      if (typeof value === 'number') {
        value = String(value);
      } else if (value instanceof Date) {
        value = value.toISOString()
      }

      if (value instanceof File || typeof value === 'string') {
        formData.append(f, value);
      } else {
        console.warn(`Unsupported type for field "${f}":`, value);
      }
    }
    const response = await simpleGetter(activitiesApi.createActivity, formData);
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      accessGlobalMiscState().set(
        "activitiesTriggerFetch",
        (accessGlobalMiscState().get("activitiesTriggerFetch") || 0) + 1
      );
      onClose();
    }
  }

  const isButtonDisabled = !validateFormFields();

  const onDelete = async () => {
    const meet: any = miscState.get('meetupsFormEditItem');
    if (!meet?.id) return;
  const confirmed = window.confirm(`Удалить мероприятие "${meet?.name || ''}"?`);
  if (!confirmed) return;
    const response = await simpleGetter(activitiesApi.deleteActivity, meet.id);
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      accessGlobalMiscState().set(
        "activitiesTriggerFetch",
        (accessGlobalMiscState().get("activitiesTriggerFetch") || 0) + 1
      );
      onClose();
    }
  }

  const canOwnerDelete = Boolean(meetupsFormEditItem?.id) && meetupsFormEditItem?.created_by === uniqUser.id && ((meetupsFormEditItem?.status ?? 0) < 1);

  return (
    <div className="flex flex-col flex-1 text-valley-black">
      <div className="flex flex-col flex-1 bg-white rounded-xl">
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 p-4 md:p-6">
          <ImageUploadWithPreview
            additionalClassName="flex-1"
            label="Обложка мероприятия"
            valueBase64={form.main_imageBase64}
            value={form.main_image}
            onChange={onFormInputChange('main_image', 'file')}
            placeholder="Загрузить обложку"
          />

          <div className="flex flex-col flex-1 gap-4 md:gap-6">
            <InputField
              value={form.department_id}
              handleChange={onFormInputChange('department_id', 'select')}
              label="Департамент"
              id="department"
              placeholder=""
              type="select"
              options={departments.map(c => ({ value: c.id, label: c.title }))}
            />
            <InputField
              value={form.category_id}
              handleChange={onFormInputChange('category_id', 'select')}
              label="Категория"
              id="category"
              placeholder=""
              type="select"
              options={categories.map(c => ({ value: c.id, label: c.name }))}
            />
            <div className="flex flex-col">
              <p className="text-[#5F6B88] font-medium text-sm">Дата начала</p>
              <DatePicker
                selected={form.start_date}
                onChange={onFormInputChangeDate('start_date')}
                customInput={<CustomDateInput />}
                dateFormat="dd/MM/yyyy HH:mm"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="Время"
              />
            </div>
            <div className="flex flex-col">
              <p className="text-[#5F6B88] font-medium text-sm">Дата конца</p>
              <DatePicker
                selected={form.end_date}
                onChange={onFormInputChangeDate('end_date')}
                customInput={<CustomDateInput />}
                dateFormat="dd/MM/yyyy HH:mm"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="Время"
              />
            </div>
          </div>
        </div>

        <InputField
          additionalClassName="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
          value={form.name}
          handleChange={onFormInputChange('name', 'text')}
          type="text"
          label="Заголовок события"
          id="activityName"
          placeholder="Введите заголовок"
        />

        <InputField
          additionalClassName="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
          value={form.location}
          handleChange={onFormInputChange('location', 'text')}
          type="text"
          label="Локация"
          id="activityLocation"
          placeholder="Введите место проведения мероприятия"
        />

        <InputField
          additionalClassName="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
          value={form.activity_target_audience_id}
          handleChange={onFormInputChange('activity_target_audience_id', 'select')}
          type="select"
          label="Целевая аудитория"
          id="activityTargetAudience"
          options={[targetAudienceEmptyOption, ...targetAudiences.map(a => ({ label: a.label, value: a.id }))]}
        />
        <InputField
          additionalClassName="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
          value={form.expected_reach}
          handleChange={onFormInputChange('expected_reach', 'select')}
          type="select"
          label="Ожидаемый охват"
          id="activityExpectedReach"
          options={activityExpectedReach.map(c => ({ label: c, value: c }))}
        />
        <InputField
          additionalClassName="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
          value={form.level}
          handleChange={onFormInputChange('level', 'select')}
          type="select"
          label="Уровень"
          id="activityLevel"
          options={activityLevels.map(c => ({ label: c, value: c }))}
        />
        <InputField
          additionalClassName="bg-[#F0F3FA] w-full px-4 py-3 rounded-lg mt-2 outline-none"
          checked={form.accept_applications}
          handleChange={onFormInputChange('accept_applications', 'checkbox')}
          type="checkbox"
          label="Приём заявок"
          id="activityAcceptApplications"
        />

        <div className="flex flex-col flex-1 p-4 md:p-6 pt-0">
          <p className="text-[#5F6B88] font-medium text-sm mb-2">Текст события</p>
          <ReactQuill
            className="bg-[#F0F3FA] w-full rounded-lg resize-none min-h-[200px] md:min-h-[25vh] outline-none overflow-hidden flex-1"
            theme="snow"
            value={form.description}
            onChange={onFormInputChangeRaw('description')}
            modules={{
              toolbar: [
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image'],
                ['clean']
              ]
            }}
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 p-4 md:p-6 pt-0 border-t border-gray-100">
        <DefaultButton
          additionalStyle={
            "text-[#F12D2D] border border-[#F12D2D] w-full sm:w-1/2 rounded-lg"
          }
          buttonText="Отмена"
          onClick={onClose}
        />
        {canOwnerDelete && (
          <DefaultButton
            additionalStyle={
              "text-[#F12D2D] border border-[#F12D2D] w-full sm:w-1/2 rounded-lg"
            }
            buttonText="Удалить"
            Icon={TrashRed}
            onClick={onDelete}
          />
        )}

        <DefaultButton
          additionalStyle={
            "bg-[#3BBC30] w-full sm:w-1/2 border border-[#3BBC30] rounded-lg text-white"
          }
          buttonText={meetupsFormEditItem?.id ? "Сохранить" : "Отправить на утверждение"}
          Icon={Tick}
          onClick={onSubmit}
          disabled={isButtonDisabled}
        />
      </div>
    </div>
  );
}
